// The one mapping from a user's role to the screen they land on. Post-OTP
// navigation (Verification.jsx) and the role-mismatch redirect in the route
// guards must agree on this, or a bounced user can ping-pong between guards —
// so both read it from here.
export function getLandingRouteForUser(user) {
  const userType = user?.userType;

  if (userType === "advisor") return "/advisor-meetings";
  if (userType === "admin" || userType === "super-admin") return "/admin-dashboard";
  if (userType === "client") {
    const isDashboardReady =
      Array.isArray(user?.onBoardingInfoId) && user.onBoardingInfoId.length > 0;
    return isDashboardReady ? "/dashboard" : "/welcome";
  }

  // Unrecognised role: /login is the only target guaranteed not to be behind a
  // role guard, so it can't produce a redirect loop.
  return "/login";
}
